module.exports = __webpack_public_path__ + "static/media/cognes.02a2bb43.png";